import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Menu, MenuItem, Box } from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';

interface LanguageSelectorProps {
  isDark?: boolean;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ isDark = true }) => {
  const { t, i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (lang: string) => {
    i18n.changeLanguage(lang);
    handleClose();
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <IconButton
        onClick={handleClick}
        sx={{
          color: isDark ? 'white' : 'primary.main',
          backgroundColor: isDark ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
          '&:hover': {
            backgroundColor: isDark ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)',
          },
          padding: 1,
        }}
      >
        <LanguageIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={() => handleLanguageChange('en')} sx={{ minWidth: 150 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <span>{t('common.english')}</span>
          </Box>
        </MenuItem>
        <MenuItem onClick={() => handleLanguageChange('ms')} sx={{ minWidth: 150 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <span>{t('common.malay')}</span>
          </Box>
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default LanguageSelector;
